<script setup lang="ts">
defineProps<{ data: HeroDualMediaProps }>()
</script>

<template>
  <div class="text-neon-yellow relative h-svh w-full lg:h-screen">
    <div class="flex h-full">
      <div class="absolute top-0 left-0 size-full bg-black opacity-20" />
      <CommonMedia
        :loading="'eager'"
        :sizes="['50vw', '40vw']"
        :media="data.medias?.[0]"
        class="max-xl:w-full xl:w-1/2"
        :fill="'both'"
        :aspect="[4 / 5, 8 / 9]"
      />

      <CommonMedia
        :loading="'eager'"
        :sizes="['50vw', '40vw']"
        :media="data.medias?.[1]"
        class="w-1/2 max-xl:hidden"
        :fill="'both'"
        :aspect="[4 / 5, 8 / 9]"
      />
    </div>

    <div
      class="absolute z-1 grid h-full w-full grid-cols-1 gap-y-4 max-xl:bottom-0 max-xl:max-h-2/3 max-xl:pb-20 xl:top-0 xl:h-full xl:grid-cols-[1fr_auto_1fr] xl:items-center"
    >
      <IconsN
        class="h-full max-w-1/4 max-xl:col-start-1 max-xl:row-start-1 xl:max-w-1/2"
        :class="data.icons ? 'opacity-100' : 'opacity-0'"
      />

      <div
        class="px-bleed flex flex-col items-center gap-7 max-xl:col-span-full max-xl:mt-auto xl:px-0"
      >
        <ElementsPortableTextWrapper class="max-w-xl text-center text-lg" :content="data.text" />
        <ElementsButton
          v-for="(link, index) in data.callToAction"
          :key="index"
          :link="link"
          class="before:bg-neon-yellow text-black"
        />
      </div>

      <IconsX
        class="ml-auto h-full max-w-1/4 max-xl:col-start-1 max-xl:row-start-1 xl:max-w-1/2"
        :class="data.icons ? 'opacity-100' : 'opacity-0'"
      />
    </div>
  </div>
</template>
